import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import { Formik } from "formik";
import React from "react";
import { useMutation } from "react-query";
import { v4 as uuid } from "uuid";
import { number, object, string } from "yup";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import {
  AddPbiReportGroupRequest,
  AddPbiReportGroupResponse,
  GetPbiReportsResponse,
} from "../../../models/pBIReport.model";
import {
  AddPbiReportGroup,
  EditPbiReportGroups,
} from "../../../services/pBIReport.service";
const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "3vh",
  // direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

const editReportValidationSchema = object().shape({
  title: string()
    .ensure()
    .required("لطفا نام فارسی را وارد نمایید")
    .max(150, "نام فارسی نباید بیش از ۱۵۰ کاراکتر باشد"),
  name: string()
    .ensure()
    .required("لطفا نام انگلیسی را وارد نمایید")
    .max(150, "نام انگلیسی نباید بیش از ۱۵۰ کاراکتر باشد"),
  orderIndex: number().required("لطفا ترتیب نمایش گزارش را وارد نمایید"),
});

interface Props {
  openAddReportModal: boolean;
  setOpenAddReportModal: (openAddReportModal: boolean) => void;
  setUpdateReports: (state: string) => void;
  addOrEdit: "Add" | "Edit";
  choosedReport: GetPbiReportsResponse;
}

const AddEditReportModal = ({
  openAddReportModal,
  setOpenAddReportModal,
  setUpdateReports,
  addOrEdit,
  choosedReport,
}: Props) => {
  const initialValues: AddPbiReportGroupRequest = {
    title: addOrEdit === "Add" ? "" : choosedReport?.title,
    name: addOrEdit === "Add" ? "" : choosedReport?.name,
    orderIndex: addOrEdit === "Add" ? undefined : choosedReport?.orderIndex,
  };
  const { mutate: AddPbiReportGroupMutate } = useMutation(AddPbiReportGroup, {
    onSuccess: (data: AddPbiReportGroupResponse) => {
      if (data) {
        setOpenAddReportModal(false);
        setUpdateReports(uuid());
      }
    },
    onError: () => {},
  });
  const { mutate: EditPbiReportGroupsMutate } = useMutation(
    EditPbiReportGroups,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          setOpenAddReportModal(false);
          setUpdateReports(uuid());
        }
      },
      onError: () => {},
    }
  );

  const handleSubmitReport = (values: AddPbiReportGroupRequest) => {
    if (addOrEdit === "Add") {
      AddPbiReportGroupMutate({
        name: values.name,
        title: values.title,
        orderIndex: values.orderIndex,
      });
    } else {
      EditPbiReportGroupsMutate({
        name: values.name,
        title: values.title,
        orderIndex: values.orderIndex,
        id: choosedReport.id,
      });
    }
  };
  return (
    <>
      <div>
        <Modal
          open={openAddReportModal}
          onClose={() => setOpenAddReportModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={deactiveUserStyle}>
            <Typography
              component={"p"}
              display={"block"}
              textAlign={"center"}
              fontWeight={"bold"}
              //   marginY={"3rem"}
              fontSize={"14px"}
              color={"#1D4A87"}
            >
              {addOrEdit === "Add" ? " افزودن گروه گزارش" : "ویرایش گروه گزارش"}
            </Typography>
            <>
              <Formik
                initialValues={initialValues}
                onSubmit={handleSubmitReport}
                validateOnMount={true}
                validationSchema={editReportValidationSchema}
              >
                {({
                  handleSubmit,
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid
                      container
                      gap={"2rem"}
                      marginTop={"15px"}
                      maxWidth={"400px"}
                    >
                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          placeHolder={"نام فارسی"}
                          label={"نام فارسی"}
                          required={true}
                          name={"title"}
                          id={"title"}
                          value={values.title}
                          helperText={touched.title ? errors.title : ""}
                          error={touched.title && Boolean(errors.title)}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          placeHolder={"نام انگلیسی"}
                          label={"نام انگلیسی"}
                          required={true}
                          name={"name"}
                          id={"name"}
                          value={values.name}
                          helperText={touched.name ? errors.name : ""}
                          error={touched.name && Boolean(errors.name)}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          onKeyDown={(e) => {
                            if (
                              /^[آ-ی ء چ]+$/.test(e.key) &&
                              e.code !== "Space"
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          placeHolder={"ترتیب نمایش گزارش"}
                          label={"ترتیب نمایش گزارش"}
                          required={true}
                          name={"orderIndex"}
                          id={"orderIndex"}
                          value={values.orderIndex}
                          helperText={
                            touched.orderIndex ? errors.orderIndex : ""
                          }
                          error={
                            touched.orderIndex && Boolean(errors.orderIndex)
                          }
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyDown={(e) => {
                            if (/^(?![0-9]).*$/.test(e.key)) {
                              if (e.code !== "Backspace")
                                if (e.code !== "Delete") e.preventDefault();
                            }
                          }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Grid
                          container
                          justifyContent={"center"}
                          alignItems={"center"}
                          gap={1}
                          marginBottom={"8px"}
                        >
                          <Grid item xs={5} width={"100%"}>
                            <Button
                              fullWidth
                              type="submit"
                              variant="contained"
                              sx={{ borderRadius: "5px !important" }}
                              disabled={
                                !values.title ||
                                !values.name ||
                                !values.orderIndex
                              }
                              className={
                                !values.title ||
                                !values.name ||
                                !values.orderIndex
                                  ? "btnForm disabledBtn"
                                  : "btnForm SuccessDefault"
                              }
                            >
                              ثبت
                            </Button>
                          </Grid>
                          <Grid item xs={5} width={"100%"}>
                            <Button
                              fullWidth
                              variant="contained"
                              style={{
                                fontSize: "1rem",
                                color: "#fff",
                                height: "40px",
                                background: "#607D8B",
                              }}
                              sx={{ borderRadius: "5px !important" }}
                              onClick={() => setOpenAddReportModal(false)}
                            >
                              انصراف
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                )}
              </Formik>
            </>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default AddEditReportModal;
